export const htmlCodingQuizData = [
  {
    module: "Module 1: What is HTML?",
    questions: [
      {
        id: "htmlc1-1",
        question: "Create a proper HTML5 page structure.",
        description: "Your code snippet should include the DOCTYPE declaration, the <html> root element, and the <head> and <body> tags. Ensure you use proper semantic HTML.",
        starterCode: "<!DOCTYPE html>\n<html>\n  <head>\n    <title>My Page</title>\n  </head>\n  <body>\n    \n  </body>\n</html>",
        hint: "Make sure you include <!DOCTYPE html> at the top. This triggers standards mode in the browser.",
        ariaLabel: "Code editor for HTML structure.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 2: HTML Document Structure",
    questions: [
      {
        id: "htmlc2-1",
        question: "Add the language attribute to the root HTML element.",
        description: "Modify the <html> tag below so that the screen reader correctly interprets the language as English ('en').",
        starterCode: "<!DOCTYPE html>\n<html>\n  <head>\n    <title>Accessible Page</title>\n  </head>\n  <body>\n    <h1>Welcome!</h1>\n  </body>\n</html>",
        hint: "Add the 'lang' attribute inside the <html> tag.",
        ariaLabel: "Code editor to add lang attribute.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 3: Headings, Paragraphs & Text",
    questions: [
      {
        id: "htmlc3-1",
        question: "Structure content with appropriate heading levels.",
        description: "Organize the headings correctly. Make 'Welcome to My Site' a Level 1 heading, 'About Me' a Level 2 heading, and 'My Hobbies' a Level 3 heading.",
        starterCode: "Welcome to My Site\n\nAbout Me\n\nMy Hobbies",
        hint: "Use <h1>, <h2>, and <h3> in hierarchical order to represent the relationships between topics.",
        ariaLabel: "Code editor to organize headings.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 4: Links & Navigation",
    questions: [
      {
        id: "htmlc4-1",
        question: "Create an accessible hyperlink.",
        description: "Turn the phrase 'Learn more about Accessibility Accessibility' into a clickable link pointing to 'https://accessibility.example.com'. Do not use 'Click here'.",
        starterCode: "<p>If you want to know how it works, you should [PUT LINK HERE].</p>",
        hint: "Use an <a> tag and wrap it around descriptive text, specifying the 'href' attribute.",
        ariaLabel: "Code editor for an accessible link.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 5: Images & Alt Text",
    questions: [
      {
        id: "htmlc5-1",
        question: "Add an image with meaningful alternative text.",
        description: "Write an <img> tag that displays 'dog.jpg'. Since the dog is running on the beach, provide descriptive alternative text so blind users know what the picture displays.",
        starterCode: "<!-- Write your image tag here -->",
        hint: "Don't forget the 'alt' attribute inside your <img> tag.",
        ariaLabel: "Code editor to write an image tag.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 6: Lists & Tables",
    questions: [
      {
        id: "htmlc6-1",
        question: "Create an ordered list of programming logic.",
        description: "Create an ordered list containing three list items: 'Planning', 'Coding', and 'Testing'.",
        starterCode: "<!-- Create your ordered list here -->",
        hint: "Use the <ol> tag for the list and <li> tags for the items.",
        ariaLabel: "Code editor to create an ordered list.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 7: Forms & Input Accessibility",
    questions: [
      {
        id: "htmlc7-1",
        question: "Connect a label to an input field securely.",
        description: "Modify the code below to explicitly associate the 'First Name' `<label>` to the `<input>` element using the matching 'for' and 'id' attributes.",
        starterCode: "<label>First Name:</label>\n<input type=\"text\" name=\"fname\">",
        hint: "The `<label>` needs a 'for' attribute, and the `<input>` needs an 'id' attribute of the exact same value.",
        ariaLabel: "Code editor to associate form labels.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 8: Semantic HTML5 Elements",
    questions: [
      {
        id: "htmlc8-1",
        question: "Convert generic layout tags into Semantic HTML.",
        description: "Change the generic `<div>` tags below into appropriate semantic elements. The top div should be a `<header>`, the middle div should be `<main>`, and the bottom div should be `<footer>`.",
        starterCode: "<div class=\"header\">\n  <h1>Site Title</h1>\n</div>\n\n<div class=\"content\">\n  <p>Article text here</p>\n</div>\n\n<div class=\"footer\">\n  <p>Copyright 2026</p>\n</div>",
        hint: "Replace the <div> tags entirely. Use <header>, <main>, and <footer>.",
        ariaLabel: "Code editor to fix semantic markup.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 9: ARIA Roles & Attributes",
    questions: [
      {
        id: "htmlc9-1",
        question: "Add an ARIA state to a button.",
        description: "Imagine this button toggles a menu. Add the 'aria-expanded' attribute to this button and set it to 'false'.",
        starterCode: "<button class=\"menu-toggle\">Menu</button>",
        hint: "Use aria-expanded=\"false\" as a property on the button.",
        ariaLabel: "Code editor for adding the aria-expanded property.",
        expectedOutput: ""
      }
    ]
  },
  {
    module: "Module 10: Building a Screen Reader Friendly Page",
    questions: [
      {
        id: "htmlc10-1",
        question: "Create a Skip to Content link.",
        description: "Create an anchor <a> link at the top of the body that points to the ID 'maincontent'. It should say 'Skip to content'.",
        starterCode: "<body>\n  <!-- Add your skip link here -->\n  \n  <nav>\n    <ul>\n       <li>Home</li>\n    </ul>\n  </nav>\n  \n  <main id=\"maincontent\">\n    <h1>Welcome</h1>\n  </main>\n</body>",
        hint: "The href should be '#maincontent'.",
        ariaLabel: "Code editor for a skip navigation link.",
        expectedOutput: ""
      }
    ]
  }
];
